
import * as util from 'util'

import * as big from '../big'
import * as int64 from '../int64'
import * as uuid from '../uuid'

import * as fbe from '../fbe'
import * as core from '../core'
import * as exposed from '../exposed'

const Big = big.Big // eslint-disable-line
const Int64 = int64.Int64 // eslint-disable-line
const UInt64 = int64.UInt64 // eslint-disable-line
const UUID = uuid.UUID // eslint-disable-line

/**
 * SymbolDayProfitLossMultipleInfoNotify struct
 */
class SymbolDayProfitLossMultipleInfoNotify {
  /**
   * Initialize struct
   * @param {!Map=} dayProfitLoss
   * @constructor
   */
  constructor (dayProfitLoss = new Map()) {
    this.DayProfitLoss = dayProfitLoss
  }

  /**
   * Copy struct (shallow copy)
   * @this {!SymbolDayProfitLossMultipleInfoNotify}
   * @param {!SymbolDayProfitLossMultipleInfoNotify} other Other struct
   * @returns {!SymbolDayProfitLossMultipleInfoNotify} This struct
   */
  copy (other) {
    if (other.DayProfitLoss != null) {
      this.DayProfitLoss = new Map()
      Object.keys(other.DayProfitLoss).forEach(key => {
        if (key != null) {
          let tempKey
          tempKey = key
          if (other.DayProfitLoss[key] != null) {
            let tempValue
            tempValue = other.DayProfitLoss[key]
            this.DayProfitLoss.set(tempKey, tempValue)
          } else {
            this.DayProfitLoss.set(tempKey, null)
          }
        }
      })
    } else {
      this.DayProfitLoss = null
    }
    return this
  }

  /**
   * Clone struct (deep clone)
   * @this {!SymbolDayProfitLossMultipleInfoNotify}
   * @returns {!SymbolDayProfitLossMultipleInfoNotify} Cloned struct
   */
  clone () {
    // Serialize the struct to the FBE stream
    let writer = new SymbolDayProfitLossMultipleInfoNotifyModel(new fbe.WriteBuffer())
    writer.serialize(this)

    // Deserialize the struct from the FBE stream
    let reader = new SymbolDayProfitLossMultipleInfoNotifyModel(new fbe.ReadBuffer())
    reader.attachBuffer(writer.buffer)
    return reader.deserialize().value
  }

  /**
   * Is this struct equal to other one?
   * @this {!SymbolDayProfitLossMultipleInfoNotify}
   * @param {!SymbolDayProfitLossMultipleInfoNotify} other Other struct
   * @returns {boolean} Equal result
   */
  eq (other) {
    if (!(other instanceof SymbolDayProfitLossMultipleInfoNotify)) {
      throw new TypeError('Instance of SymbolDayProfitLossMultipleInfoNotify is required!')
    }
    return true
  }

  /**
   * Convert struct to JSON
   * @this {!SymbolDayProfitLossMultipleInfoNotify}
   * @returns {!object} Struct value for JSON
   */
  toJSON () {
    return {
      DayProfitLoss: ((this.DayProfitLoss != null) ? fbe.MapToObject(new Map(Array.from(this.DayProfitLoss, item => [((item[0] != null) ? item[0] : null), ((item[1] != null) ? item[1] : null)]))) : null)
    }
  }

  /**
   * Convert JSON to struct
   * @param {!string} json JSON string
   * @returns {!object} Struct value for JSON
   */
  static fromJSON (json) {
    return SymbolDayProfitLossMultipleInfoNotify.fromObject(JSON.parse(json))
  }

  /**
   * Create struct from object value
   * @param {!SymbolDayProfitLossMultipleInfoNotify} other Object value
   * @returns {!SymbolDayProfitLossMultipleInfoNotify} Created struct
   */
  static fromObject (other) {
    return new SymbolDayProfitLossMultipleInfoNotify().copy(other)
  }

  /**
   * Get the FBE type
   * @this {!SymbolDayProfitLossMultipleInfoNotify}
   * @returns {!number} FBE type
   */
  get fbeType () {
    return SymbolDayProfitLossMultipleInfoNotify.fbeType
  }

  /**
   * Get the FBE type (static)
   * @this {!SymbolDayProfitLossMultipleInfoNotify}
   * @returns {!number} FBE type
   */
  static get fbeType () {
    return 5206
  }
}

export { SymbolDayProfitLossMultipleInfoNotify };

/**
 * Fast Binary Encoding SymbolDayProfitLossMultipleInfoNotify field model
 */
class FieldModelSymbolDayProfitLossMultipleInfoNotify extends fbe.FieldModel {
  /**
   * Initialize field model with the given buffer and offset
   * @param {!fbe.ReadBuffer|!fbe.WriteBuffer} buffer Buffer
   * @param {!number} offset Offset
   * @constructor
   */
  constructor (buffer, offset) {
    super(buffer, offset)
    this.DayProfitLoss = new fbe.FieldModelMap(new fbe.FieldModelString(buffer, 4 + 4), new fbe.FieldModelDouble(buffer, 4 + 4), buffer, 4 + 4)
  }

  /**
   * Get the field size
   * @this {!FieldModelSymbolDayProfitLossMultipleInfoNotify}
   * @returns {!number} Field size
   */
  get fbeSize () {
    return 4
  }

  /**
   * Get the field body size
   * @this {!FieldModelSymbolDayProfitLossMultipleInfoNotify}
   * @returns {!number} Field body size
   */
  get fbeBody () {
    return 4 + 4 + this.DayProfitLoss.fbeSize
  }

  /**
   * Get the field extra size
   * @this {!FieldModelSymbolDayProfitLossMultipleInfoNotify}
   * @returns {!number} Field extra size
   */
  get fbeExtra () {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4) > this._buffer.size)) {
      return 0
    }

    this._buffer.shift(fbeStructOffset)

    let fbeResult = this.fbeBody + this.DayProfitLoss.fbeExtra

    this._buffer.unshift(fbeStructOffset)

    return fbeResult
  }

  /**
   * Get the field type
   * @this {!FieldModelSymbolDayProfitLossMultipleInfoNotify}
   * @returns {!number} Field type
   */
  get fbeType () {
    return FieldModelSymbolDayProfitLossMultipleInfoNotify.fbeType
  }

  /**
   * Get the field type (static)
   * @this {!FieldModelSymbolDayProfitLossMultipleInfoNotify}
   * @returns {!number} Field type
   */
  static get fbeType () {
    return 5206
  }

  /**
   * Check if the struct value is valid
   * @this {!FieldModelSymbolDayProfitLossMultipleInfoNotify}
   * @param {!boolean} fbeVerifyType Verify model type flag, defaults is true
   * @returns {!boolean} Field model valid state
   */
  verify (fbeVerifyType = true) {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return true
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4 + 4) > this._buffer.size)) {
      return false
    }

    let fbeStructSize = this.readUInt32(fbeStructOffset)
    if (fbeStructSize < (4 + 4)) {
      return false
    }

    let fbeStructType = this.readUInt32(fbeStructOffset + 4)
    if (fbeVerifyType && (fbeStructType !== this.fbeType)) {
      return false
    }

    this._buffer.shift(fbeStructOffset)
    let fbeResult = this.verifyFields(fbeStructSize)
    this._buffer.unshift(fbeStructOffset)
    return fbeResult
  }

  /**
   * Check if the struct fields are valid
   * @this {!FieldModelSymbolDayProfitLossMultipleInfoNotify}
   * @param {!number} fbeStructSize FBE struct size
   * @returns {!boolean} Field model valid state
   */
  verifyFields (fbeStructSize) {
    let fbeCurrentSize = 4 + 4

    if ((fbeCurrentSize + this.DayProfitLoss.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.DayProfitLoss.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.DayProfitLoss.fbeSize

    return true
  }

  /**
   * Get the struct value (begin phase)
   * @this {!FieldModelSymbolDayProfitLossMultipleInfoNotify}
   * @returns {!number} Field model begin offset
   */
  getBegin () {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    console.assert((fbeStructOffset > 0) && ((this._buffer.offset + fbeStructOffset + 4 + 4) <= this._buffer.size), 'Model is broken!')
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4 + 4) > this._buffer.size)) {
      return 0
    }

    let fbeStructSize = this.readUInt32(fbeStructOffset)
    console.assert((fbeStructSize >= (4 + 4)), 'Model is broken!')
    if (fbeStructSize < (4 + 4)) {
      return 0
    }

    this._buffer.shift(fbeStructOffset)
    return fbeStructOffset
  }

  /**
   * Get the struct value (end phase)
   * @this {!FieldModelSymbolDayProfitLossMultipleInfoNotify}
   * @param {!number} fbeBegin Field model begin offset
   */
  getEnd (fbeBegin) {
    this._buffer.unshift(fbeBegin)
  }

  /**
   * Get the struct value
   * @this {!FieldModelSymbolDayProfitLossMultipleInfoNotify}
   * @param {!SymbolDayProfitLossMultipleInfoNotify} fbeValue Default value, defaults is new SymbolDayProfitLossMultipleInfoNotify()
   * @returns {!SymbolDayProfitLossMultipleInfoNotify} SymbolDayProfitLossMultipleInfoNotify value
   */
  get (fbeValue = new SymbolDayProfitLossMultipleInfoNotify()) {
    let fbeBegin = this.getBegin()
    if (fbeBegin === 0) {
      return fbeValue
    }

    let fbeStructSize = this.readUInt32(0)
    this.getFields(fbeValue, fbeStructSize)
    this.getEnd(fbeBegin)
    return fbeValue
  }

  /**
   * Get the struct fields values
   * @this {!FieldModelSymbolDayProfitLossMultipleInfoNotify}
   * @param {!SymbolDayProfitLossMultipleInfoNotify} fbeValue SymbolDayProfitLossMultipleInfoNotify value
   * @param {!number} fbeStructSize Struct size
   */
  getFields (fbeValue, fbeStructSize) {
    let fbeCurrentSize = 4 + 4

    if ((fbeCurrentSize + this.DayProfitLoss.fbeSize) <= fbeStructSize) {
      this.DayProfitLoss.get(fbeValue.DayProfitLoss)
    } else {
      fbeValue.DayProfitLoss.clear()
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.DayProfitLoss.fbeSize
  }

  /**
   * Set the struct value (begin phase)
   * @this {!FieldModelSymbolDayProfitLossMultipleInfoNotify}
   * @returns {!number} Field model begin offset
   */
  setBegin () {
    console.assert(((this._buffer.offset + this.fbeOffset + this.fbeSize) <= this._buffer.size), 'Model is broken!')
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructSize = this.fbeBody
    let fbeStructOffset = this._buffer.allocate(fbeStructSize) - this._buffer.offset
    console.assert((fbeStructOffset > 0) && ((this._buffer.offset + fbeStructOffset + fbeStructSize) <= this._buffer.size), 'Model is broken!')
    if ((fbeStructOffset <= 0) || ((this._buffer.offset + fbeStructOffset + fbeStructSize) > this._buffer.size)) {
      return 0
    }

    this.writeUInt32(this.fbeOffset, fbeStructOffset)
    this.writeUInt32(fbeStructOffset, fbeStructSize)
    this.writeUInt32(fbeStructOffset + 4, this.fbeType)

    this._buffer.shift(fbeStructOffset)
    return fbeStructOffset
  }

  /**
   * Set the struct value (end phase)
   * @this {!FieldModelSymbolDayProfitLossMultipleInfoNotify}
   * @param {!number} fbeBegin Field model begin offset
   */
  setEnd (fbeBegin) {
    this._buffer.unshift(fbeBegin)
  }

  /**
   * Set the struct value
   * @this {!FieldModelSymbolDayProfitLossMultipleInfoNotify}
   * @param {!SymbolDayProfitLossMultipleInfoNotify} fbeValue SymbolDayProfitLossMultipleInfoNotify value
   */
  set (fbeValue) {
    let fbeBegin = this.setBegin()
    if (fbeBegin === 0) {
      return
    }

    this.setFields(fbeValue)
    this.setEnd(fbeBegin)
  }

  /**
   * Set the struct fields values
   * @this {!FieldModelSymbolDayProfitLossMultipleInfoNotify}
   * @param {SymbolDayProfitLossMultipleInfoNotify} fbeValue SymbolDayProfitLossMultipleInfoNotify value
   */
  setFields (fbeValue) {
    this.DayProfitLoss.set(fbeValue.DayProfitLoss)
  }
}

export { FieldModelSymbolDayProfitLossMultipleInfoNotify };

/**
 * Fast Binary Encoding SymbolDayProfitLossMultipleInfoNotify model
 */
class SymbolDayProfitLossMultipleInfoNotifyModel extends fbe.Model {
  /**
   * Initialize model with the given buffer
   * @param {!fbe.ReadBuffer|!fbe.WriteBuffer} buffer Read/Write buffer, defaults is new fbe.WriteBuffer()
   * @constructor
   */
  constructor (buffer = new fbe.WriteBuffer()) {
    super(buffer)
    this._model = new FieldModelSymbolDayProfitLossMultipleInfoNotify(this.buffer, 4)
  }

  /**
   * Get the SymbolDayProfitLossMultipleInfoNotify model
   * @this {!SymbolDayProfitLossMultipleInfoNotifyModel}
   * @returns {!FieldModelSymbolDayProfitLossMultipleInfoNotify} model SymbolDayProfitLossMultipleInfoNotify model
   */
  get model () {
    return this._model
  }

  /**
   * Get the model size
   * @this {!SymbolDayProfitLossMultipleInfoNotifyModel}
   * @returns {!number} Model size
   */
  get fbeSize () {
    return this.model.fbeSize + this.model.fbeExtra
  }

  /**
   * Get the model type
   * @this {!SymbolDayProfitLossMultipleInfoNotifyModel}
   * @returns {!number} Model type
   */
  get fbeType () {
    return SymbolDayProfitLossMultipleInfoNotifyModel.fbeType
  }

  /**
   * Get the model type (static)
   * @this {!SymbolDayProfitLossMultipleInfoNotifyModel}
   * @returns {!number} Model type
   */
  static get fbeType () {
    return FieldModelSymbolDayProfitLossMultipleInfoNotify.fbeType
  }

  /**
   * Check if the struct value is valid
   * @this {!SymbolDayProfitLossMultipleInfoNotifyModel}
   * @returns {!boolean} Model valid state
   */
  verify () {
    if ((this.buffer.offset + this.model.fbeOffset - 4) > this.buffer.size) {
      return false
    }

    let fbeFullSize = this.readUInt32(this.model.fbeOffset - 4)
    if (fbeFullSize < this.model.fbeSize) {
      return false
    }

    return this.model.verify()
  }

  /**
   * Create a new model (begin phase)
   * @this {!SymbolDayProfitLossMultipleInfoNotifyModel}
   * @returns {!number} Model begin offset
   */
  createBegin () {
    return this.buffer.allocate(4 + this.model.fbeSize)
  }

  /**
   * Create a new model (end phase)
   * @this {!SymbolDayProfitLossMultipleInfoNotifyModel}
   * @param {!number} fbeBegin Model begin offset
   */
  createEnd (fbeBegin) {
    let fbeEnd = this.buffer.size
    let fbeFullSize = fbeEnd - fbeBegin
    this.writeUInt32(this.model.fbeOffset - 4, fbeFullSize)
    return fbeFullSize
  }

  /**
   * Serialize the struct value
   * @this {!SymbolDayProfitLossMultipleInfoNotifyModel}
   * @param {!SymbolDayProfitLossMultipleInfoNotify} value SymbolDayProfitLossMultipleInfoNotify value
   * @return {!number} Model begin offset
   */
  serialize (value) {
    let fbeBegin = this.createBegin()
    this.model.set(value)
    return this.createEnd(fbeBegin)
  }

  /**
   * Deserialize the struct value
   * @this {!SymbolDayProfitLossMultipleInfoNotifyModel}
   * @param {!SymbolDayProfitLossMultipleInfoNotify} value SymbolDayProfitLossMultipleInfoNotify value, defaults is new SymbolDayProfitLossMultipleInfoNotify()
   * @return {!object} Deserialized SymbolDayProfitLossMultipleInfoNotify value and its size
   */
  deserialize (value = new SymbolDayProfitLossMultipleInfoNotify()) {
    if ((this.buffer.offset + this.model.fbeOffset - 4) > this.buffer.size) {
      return { value: new SymbolDayProfitLossMultipleInfoNotify(), size: 0 }
    }

    let fbeFullSize = this.readUInt32(this.model.fbeOffset - 4)
    console.assert((fbeFullSize >= this.model.fbeSize), 'Model is broken!')
    if (fbeFullSize < this.model.fbeSize) {
      return { value: new SymbolDayProfitLossMultipleInfoNotify(), size: 0 }
    }

    this.model.get(value)
    return { value: value, size: fbeFullSize }
  }

  /**
   * Move to the next struct value
   * @this {!SymbolDayProfitLossMultipleInfoNotifyModel}
   * @param {!number} prev Previous SymbolDayProfitLossMultipleInfoNotify model size
   */
  next (prev) {
    this.model.fbeShift(prev)
  }
}

export { SymbolDayProfitLossMultipleInfoNotifyModel };
